document.addEventListener('turbo:load', () => {
    (function () {
        const themeSwitcher = document.querySelector('#themeSwitcher')
        const userTheme = localStorage.getItem('theme')
        const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches

        const themeCheck = () => {
            if (userTheme === 'dark' || (!userTheme && systemTheme)) {
                document.documentElement.classList.add('dark')
            }
        }

        const themeSwitch = () => {
            if (document.documentElement.classList.contains('dark')) {
                document.documentElement.classList.remove('dark')
                localStorage.setItem('theme', 'light')
                console.log('💡Changed to light theme')
            } else {
                document.documentElement.classList.add('dark')
                localStorage.setItem('theme', 'dark')
                console.log('🌙Changed to dark theme')
            }
        }

        themeCheck()

        themeSwitcher.addEventListener('click', () => {
            themeSwitch()
        })
    })()
})
